import {DataGridPro, GridRowId} from '@mui/x-data-grid-pro'
import {envImagePath} from 'GLOBAL/envVariables'
import CustomerDetailInfoMdal from 'pages/common/CustomerDetailInfoMdal'
import ExcelDownLoadModal from 'pages/common/ExcelDownloadModal'
import PhotoModal from 'pages/common/PhotoModal'
import {customerBinaryCheckColumns} from 'pages/customer/dataConfig/declearColumns'
import {customerBinaryCheckFilter} from 'pages/customer/dataConfig/declearFilters'
import {customerBinaryCheckRows} from 'pages/customer/dataConfig/declearRows'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {toast, ToastContainer} from 'react-toastify'
import {getAsCauseList, getCustomerBinaryCheckList} from 'utils/apiCalling/api'
import CustomPagination from 'utils/designSytem/CustomPagination'
import useSelectionRemap from 'utils/hooks/useSelectionRemap'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {
  customerDetailModalClose,
  customerDetailModalOpen,
  onRowsSelectionHandler,
  photoModalClose,
  photoModalOpen,
  scrollTop,
} from 'utils/func/justUtils'
import {toolTipText} from 'utils/toolTips/toolTipText'
import {customerBinaryCheckGroup} from '../dataConfig/declearGroupingModel'
import {customerBinaryCheckSearchOption} from '../dataConfig/declearSearchOptions'
import AsBatchOffcanvas from '../modules/asBatchOffcanvas'

import Hex from 'crypto-js/enc-hex'
import SHA256 from 'crypto-js/sha256'

const CustomerBinaryCheck = (props: any) => {
  /*********************************************************************
   ** Test Data
   *********************************************************************/

  /*********************************************************************
   * 0. Types
   *********************************************************************/

  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/
  const location = useLocation()
  const pageState = location?.state
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  const officeInfo = useSelector((state: any) => state?.officeInfo)
  const cooperInfo = useSelector((state: any) => state?.cooperInfo)
  /*********************************************************************
   * 2. State settings (useState)
   *********************************************************************/
  const [asReasonData, setAsReasonData] = useState<any>('')
  const [checkData, setCheckData] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [customerDetailData, setCustomerDetailData] = useState<any>(null)
  const [isZoomOpen, setIsZoomOpen] = useState<boolean>(false)
  const [causeList, setCauseList] = useState<any>(null)
  const [customerInfoList, setCustomerInfoList] = useState<any>(null)
  const [selectedRow, setSelectedRow] = useState<any>({})
  const [selectionModel, setSelectionModel] = useState<GridRowId[]>([])
  const [totalCount, setTotalCount] = useState<any>(null)
  const [filter, setFilter] = useState<any>(customerBinaryCheckFilter(pageState))
  const [customerDetailOpen, setCustomerDetailOpen] = useState<boolean>(false)
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false)
  const [downloadOpen, setDownloadOpen] = useState<boolean>(false)
  const [photoData, setPhotoData] = useState<any>({})
  const [targetRowId, setTargetRowId] = useState<any>(0)
  const [photoModal, setPhotoModal] = useState<boolean>(false)
  const [rows, setRows] = useState<any[]>([])
  const [shouldCallApi, setShouldCallApi] = useState<boolean>(false)

  useSelectionRemap({rows, checkData, selectionModel, setCheckData, setSelectionModel})

  /*********************************************************************
   * 4. Handlers (function)
   *********************************************************************/
  const handleResponse = async (res: any, count: any) => {
    let rows = customerBinaryCheckRows(res)
    setCustomerInfoList(res)
    setRows(rows)
    setTotalCount(count)

    const updates: any[] = []

    // canvas 기반 해시 (subtle + fallback)
    const getCanvasHash = async (
      url: string,
      forceFront = false
    ): Promise<{hash: string | null; width: number | null; height: number | null}> => {
      return new Promise((resolve) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.src = url

        img.onload = async () => {
          try {
            const canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            const ctx = canvas.getContext('2d')!
            ctx.drawImage(img, 0, 0)

            const {data} = ctx.getImageData(0, 0, canvas.width, canvas.height)

            let hashHex: string | null = null

            if (window.crypto?.subtle) {
              const hashBuffer = await window.crypto.subtle.digest('SHA-256', data.buffer)
              const hashArray = Array.from(new Uint8Array(hashBuffer))
              hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
            } else {
              const wordArray = Hex.parse(
                Array.from(data)
                  .map((b) => b.toString(16).padStart(2, '0'))
                  .join('')
              )
              hashHex = SHA256(wordArray).toString(Hex)
            }

            if (forceFront && hashHex) hashHex += '*'

            resolve({hash: hashHex, width: img.width, height: img.height})
          } catch (err) {
            console.error('canvas 해시 계산 실패', err)
            resolve({hash: null, width: null, height: null})
          }
        }

        img.onerror = (err) => {
          console.error('이미지 로드 실패', err)
          resolve({hash: null, width: null, height: null})
        }
      })
    }

    const processFileHash = async (
      id: number,
      path: string,
      type: 's' | 'e',
      forceFront = false
    ) => {
      if (!path) return null
      const url = envImagePath + path
      const {hash, width, height} = await getCanvasHash(url, forceFront)

      return {
        id,
        ...(type === 's'
          ? {simageHash: hash, simageWidth: width, simageHeight: height}
          : {eimageHash: hash, eimageWidth: width, eimageHeight: height}),
      }
    }

    await Promise.all(
      rows.map(async (row) => {
        // 둘 다 있으면 그대로 사용
        if (row.simageHash && row.eimageHash) {
          return null
        }

        // 둘 중 하나라도 없으면 둘 다 프론트 해시로 다시 계산
        const tasks: any[] = []
        if (row.sfilePath) {
          const s = await processFileHash(row.id, row.sfilePath, 's', true)
          if (s) tasks.push(s)
        }
        if (row.efilePath) {
          const e = await processFileHash(row.id, row.efilePath, 'e', true)
          if (e) tasks.push(e)
        }
        updates.push(...tasks)
      })
    )

    // 최종 업데이트 적용
    setRows((prev) =>
      prev.map((r) => {
        const us = updates.filter((u) => u.id === r.id)
        return us.length ? {...r, ...Object.assign({}, ...us)} : r
      })
    )
  }

  const getCustomerInfo = async () => {
    let searchFilter = {...filter}

    // 다중선택 필터꺼버림
    if (searchFilter?.searchDataFieldBinaryCheck) {
      const field = searchFilter.searchDataFieldBinaryCheck
      if (searchFilter.searchOption && field in searchFilter.searchOption) {
        searchFilter.searchOption = {
          ...searchFilter.searchOption,
          [field]: true,
        }
      }
      delete searchFilter.searchDataFieldBinaryCheck
    }

    await getCustomerBinaryCheckList(
      officeInfo,
      cooperInfo,
      searchFilter,
      async (res: any, count: any) => {
        handleResponse(res, count)
      },
      (error: any) => {},
      (props: any) => {
        setLoading(props)
      }
    )
  }

  const openCustomerDetailModal = () => customerDetailModalOpen(setCustomerDetailOpen)
  const closeCustomerDetailModal = () => customerDetailModalClose(setCustomerDetailOpen)
  const closePhotoModal = () => photoModalClose(setPhotoModal)
  const openPhotoModal = () => photoModalOpen(setPhotoModal)

  const columnGroupingModel = customerBinaryCheckGroup

  const resetHandler = () => {
    setFilter(customerBinaryCheckFilter(pageState))
    setShouldCallApi(true)
  }

  const searchHandler = () => {
    setFilter((prev: any) => ({...prev, page: 1}))
    setShouldCallApi(true)
  }

  const getRowHeightOnDataGrid = (params: any) => {
    const {simageHeight, eimageHeight} = params?.model || {}
    const heightMap: Record<number, number> = {
      480: 280,
      240: 260,
      144: 160,
    }

    const imageHeight = Math.max(simageHeight || 0, eimageHeight || 0)
    if (imageHeight && heightMap[imageHeight]) {
      return heightMap[imageHeight]
    }
    return 180
  }
  /*********************************************************************
   * 5. UseEffect
   *********************************************************************/
  useEffect(() => {
    if (shouldCallApi) {
      getCustomerInfo()
      setShouldCallApi(false)
    }
  }, [filter, shouldCallApi])

  useEffect(() => {
    scrollTop()
    getAsCauseList(setCauseList)
    getCustomerInfo()
  }, [
    filter?.efosStatus,
    filter?.deviceStatus,
    filter?.deviceType,
    filter?.compareType,
    filter?.processStatus,
    filter.rowPerPage,
    filter.page,
    filter?.recognizedType,
    filter?.customerStatus,
    officeInfo,
    cooperInfo,
  ])

  useEffect(() => {
    setFilter(customerBinaryCheckFilter(pageState))
  }, [officeInfo?.value])

  /*********************************************************************
   * 6. DataGrid Props settings
   *********************************************************************/
  const columns: any = customerBinaryCheckColumns(
    openCustomerDetailModal,
    setCustomerDetailData,
    userInfo,
    getCustomerInfo,
    officeInfo,
    openPhotoModal,
    setPhotoData,
    setTargetRowId,
    setSelectedRow,
    setIsZoomOpen
  )
  /*********************************************************************
   * 7. Page configuration
   *********************************************************************/
  return (
    <>
      <MeterariumPageLayout
        headerDescription={toolTipText.customerBinaryCheck.description}
        tooltipText={toolTipText.customerBinaryCheck.text}
        hideSearchOptions={accordionOpen}
        setHideSearchOptions={setAccordionOpen}
        filter={filter}
        id={'customer-info'}
        setFilter={setFilter}
        searchCallback={searchHandler}
        total={totalCount}
        control={[]}
        actions={['download', 'as']}
        searchOptions={[]}
        checkData={checkData}
        selectedCount={selectionModel.length}
        asValue={{
          asReasonData,
          setAsReasonData,
          setSelectionModel,
          setCheckData,
          causeList,
          // A/S 등록·취소 후 갱신은 현재 페이지를 유지한다
          // (searchCallback은 검색용이라 page를 1로 되돌린다)
          refreshCallback: () => setShouldCallApi(true),
        }}
        resetCallbalck={resetHandler}
        newSearchOptions={customerBinaryCheckSearchOption}
        newSearchField={true}
        newSearchFieldFilter={{}}
        onDownloadOpen={() => setDownloadOpen(true)}
        loading={loading}
      >
        <DataGridPro
          rowHeight={180}
          getRowHeight={(params: any) => getRowHeightOnDataGrid(params)}
          headerHeight={30}
          autoHeight={true}
          columnGroupingModel={columnGroupingModel}
          experimentalFeatures={{columnGrouping: true}}
          rows={rows}
          rowCount={rows?.length}
          columns={columns}
          disableColumnMenu
          checkboxSelection
          onSelectionModelChange={(ids, selection) => {
            const selectedRowsData = ids.map((id) => rows.find((row: any) => row.id === id))
            onRowsSelectionHandler(ids, [
              [setCheckData, selectedRowsData],
              [setSelectionModel, ids],
            ])
          }}
          selectionModel={selectionModel}
          loading={loading}
          paginationMode={'server'}
          hideFooterPagination={true}
          pagination={true}
          hideFooter={true}
          sx={{
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f9fafb',
            },
            '& .MuiDataGrid-row.row-error': {
              backgroundColor: '#ffe4e6',
            },
            '& .MuiDataGrid-row.row-error:hover': {
              backgroundColor: '#ffe4e6',
            },
          }}
          getRowClassName={(params) => {
            const {simageHash, eimageHash} = params.row
            if (simageHash === null || eimageHash === null) {
              return ''
            } else if (simageHash === eimageHash) return 'row-error'
            return ''
          }}
        />

        <CustomPagination filter={filter} setFilter={setFilter} totalCount={totalCount} />
      </MeterariumPageLayout>

      <CustomerDetailInfoMdal
        data={customerDetailData}
        open={customerDetailOpen}
        onClose={closeCustomerDetailModal}
        getList={getCustomerInfo}
      />

      <PhotoModal
        setData={setPhotoData}
        data={photoData}
        open={photoModal}
        onClose={closePhotoModal}
        page='info'
        rowCount={targetRowId}
        filter={filter}
        pagenation={filter.page}
        perPage={filter.rowPerPage}
        getList={getCustomerInfo}
        count={totalCount}
      />

      <ExcelDownLoadModal
        type={'검침 이미지 검증'}
        search={filter}
        open={downloadOpen}
        onClose={() => setDownloadOpen(false)}
      />
      <AsBatchOffcanvas toast={toast} />
      <ToastContainer />

      {isZoomOpen && selectedRow && (
        <div className='fixed top-[30%] left-[40%] -translate-x-1/2 z-50'>
          <div className='relative bg-black/90 text-white p-4 rounded-lg flex flex-col gap-6'>
            {/* 시작 이미지 */}
            <div className='flex flex-col items-center flex-1'>
              <span className='mb-2 text-base font-semibold'>시작 이미지</span>
              <img
                src={`${envImagePath}${selectedRow.sfilePath}`}
                alt='시작 이미지'
                className='w-auto min-w-[320px] min-h-[300px] max-h-[300px] object-contain rounded border'
                style={{
                  transform: `${
                    selectedRow.filePath &&
                    ((Number(selectedRow.rotate) > 90 && Number(selectedRow.rotate) < 270) ||
                      (Number(selectedRow.rotate) < -90 && Number(selectedRow.rotate) > -270))
                      ? `rotate(180deg)`
                      : 'rotate(0deg)'
                  }`,
                }}
              />
            </div>

            {/* 마지막 이미지 */}
            <div className='flex flex-col items-center flex-1'>
              <span className='mb-2 text-base font-semibold'>마지막 이미지</span>
              <img
                src={`${envImagePath}${selectedRow.efilePath}`}
                alt='마지막 이미지'
                className='w-auto min-w-[320px] min-h-[300px] max-h-[300px] object-contain rounded border'
                style={{
                  transform: `${
                    selectedRow.filePath &&
                    ((Number(selectedRow.rotate) > 90 && Number(selectedRow.rotate) < 270) ||
                      (Number(selectedRow.rotate) < -90 && Number(selectedRow.rotate) > -270))
                      ? `rotate(180deg)`
                      : 'rotate(0deg)'
                  }`,
                }}
              />
            </div>

            {/* 닫기 버튼 */}
            <button
              className='absolute top-2 right-2  text-white rounded-full w-8 h-8 flex items-center justify-center'
              onClick={() => setIsZoomOpen(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  )
}
export default CustomerBinaryCheck
